import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleAuthenticator = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M20.625 12C20.625 12.8025 19.9744 13.4531 19.1719 13.4531H14.1562L12 9.09326L14.3274 5.06224C14.7286 4.36726 15.6173 4.12912 16.3123 4.53034L16.3126 4.5305C17.0076 4.93174 17.2458 5.82046 16.8445 6.5155L14.5172 10.5469H19.1719C19.9744 10.5469 20.625 11.1974 20.625 12Z",
			fill: "#1A73E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3125 19.4695L16.3122 19.4696C15.6172 19.8709 14.7285 19.6327 14.3273 18.9377L11.9999 14.9067L9.67253 18.9377C9.27127 19.6327 8.3826 19.8709 7.6876 19.4696L7.68732 19.4695C6.99227 19.0682 6.7541 18.1795 7.15535 17.4845L9.48271 13.4531L11.9999 13.3594L14.5171 13.4531L16.8444 17.4845C17.2457 18.1795 17.0075 19.0682 16.3125 19.4695Z",
			fill: "#EA4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9999 9.09326L11.3437 10.875L9.48271 10.5469L7.15535 6.5155C6.7541 5.82046 6.99227 4.93174 7.68732 4.5305L7.6876 4.53034C8.3826 4.12912 9.27127 4.36726 9.67253 5.06224L11.9999 9.09326Z",
			fill: "#FBBC04"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.625 10.5469L9.9375 13.4531H4.82812C4.02559 13.4531 3.375 12.8025 3.375 12C3.375 11.1975 4.02559 10.5469 4.82812 10.5469H11.625Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5173 13.4531H9.48291L12.0001 9.09326L14.5173 13.4531Z",
			fill: "#185DB7"
		})
	]
});
const ForwardRef = forwardRef(SvgGoogleAuthenticator);
export { ForwardRef as ReactComponent };
